import { DateTime } from 'luxon';
import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

import TimeDisplay from './TimeDisplay';

type Props = {
  calledAt: string;
};

export default function PickupTime({ calledAt }: Props): React.ReactElement {
  const calledAtTime = DateTime.fromISO(calledAt);
  const computedTime = () => DateTime.now().diff(calledAtTime, 'seconds').as('seconds');

  const [pickupTime, setPickupTime] = useState<number>(computedTime());

  useInterval(() => {
    setPickupTime(computedTime);
  }, 5000);

  return <TimeDisplay title="Pickup time" time={pickupTime} />;
}
